import React from 'react';
import { Bar } from 'react-chartjs-2';

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
}  from 'chart.js';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);



export const sampleOptions = {
  responsive: true,
  plugins: {
    legend: {
      position: 'top',
    },
    title: {
      display: true,
      text: 'Bar Chart',
    },
  },
};

const labels = ['2018', '2019', '2020', '2021', '2022', 'YTD'];

export const sampleData = {
  labels: labels,
  datasets: [
    {
      label: 'Dataset 1',
      data: [6,5,4,3,2,1],
      backgroundColor: 'rgba(255, 99, 132, 0.8)',
    },
    {
      label: 'Dataset 2',
      data: [1,2,3,4,5,6],
      backgroundColor: 'rgba(53, 162, 235, 0.8)',
    },
  ],
};


export const sampleData1 = {
  labels: labels,
  datasets: [
    {
      label: 'Blue',
      data: [6,5,4,3,2,1],
      backgroundColor: 'rgba(53, 162, 235, 0.8)',
    },
    {
      label: 'Green',
      data: [1,2,3,4,5,6],
      backgroundColor: 'rgba(53, 235, 162, 0.8)',
    },
  ],
};

export const sampleData2 = {
  labels: labels,
  datasets: [
    {
      label: 'Green',
      data: [1,2,3,4,5,6],
      backgroundColor: 'rgba(53, 235, 162, 0.8)',
    },
    {
      label: 'Yellow',
      data: [4,3,2,3,4,5],
      backgroundColor: 'rgba(255, 235, 99, 0.8)',
    },
  ],

};
export const sampleData3 = {
  labels: labels,
  datasets: [
    {
      label: 'Green ',
      data: [1,2,3,4,5,6],
      backgroundColor: 'rgba(53, 235, 162, 0.8)',
    },
    {
      label: 'Yellow',
      data: [4,3,2,3,4,5],
      backgroundColor: 'rgba(255, 220, 73, 0.8)',
    },
  ],
};

export const  BarChart = ({ chartData }, {chartOptions}) => {
  return (
    <div>
      <Bar data={chartData} options={chartOptions} height="260px"/>
    </div>
  );
}

